// src/features/auth/components/RegisterForm.js
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import Input from '../../../shared/components/Input';
import Button from '../../../shared/components/Button';
import { useAuth } from '../hooks/useAuth';

const schema = yup.object({
  name: yup.string().required('Name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  password: yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .required('Password is required'),
  password_confirmation: yup.string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Password confirmation is required'),
  ohc_id: yup.number().required('OHC selection is required'),
});

const RegisterForm = () => {
  const { register: registerUser, isLoading, error, clearError } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    await registerUser(data);
  };

  return (
    <div className="max-w-md w-full mx-auto">
      <div className="text-center mb-8">
           <img 
  src="/avyukt-healthcare-logo.png" 
  alt="Logo" 
  className="mx-auto h-16 w-auto mb-4"
/>
        {/* <h2 className="text-3xl font-bold text-gray-900">Create Account</h2> */}
        <p className="text-gray-600 mt-2">Register for OHCMS access</p>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
          <button onClick={clearError} className="float-right">×</button>
        </div>
      )}

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <Input
          label="Full Name"
          type="text"
          {...register('name')}
          error={errors.name?.message}
          placeholder="Enter your full name"
        />

        <Input
          label="Email Address"
          type="email"
          {...register('email')}
          error={errors.email?.message}
          placeholder="Enter your email"
        />

        <Input
          label="Password"
          type="password"
          {...register('password')}
          error={errors.password?.message}
          placeholder="Create a password"
        />

        <Input
          label="Confirm Password"
          type="password"
          {...register('password_confirmation')}
          error={errors.password_confirmation?.message}
          placeholder="Confirm your password"
        />

        <Input
          label="OHC ID"
          type="number"
          {...register('ohc_id')}
          error={errors.ohc_id?.message}
          placeholder="Enter OHC ID"
        />

        <Button
          type="submit"
          variant="primary"
          isLoading={isLoading}
          className="w-full"
        >
          Register
        </Button>
      </form>

      <p className="mt-6 text-center text-sm text-gray-600">
        Already have an account?{' '}
        <Link to="/login" className="text-blue-600 hover:text-blue-800 font-medium">
          Sign in here
        </Link>
      </p>
    </div>
  );
};

export default RegisterForm;